import React, { useState, useEffect } from "react";
import { fetchProcurementSummary } from "../data/api";

const MedicineProcurementSection = () => {
  const [medicines, setMedicines] = useState([]);

  useEffect(() => {
    fetchProcurementSummary().then(r => {
      setMedicines(r.data.map(d => ({
        name: d.name,
        cat: d.cat,
        amc: Math.round(parseFloat(d.amc) || 0),
        stock: parseInt(d.stock) || 0,
        pipeline: parseInt(d.pipeline) || 0,
      })));
    }).catch(console.error);
  }, []);

  return (
    <div className="card-body" style={{ overflowX: "auto", padding: 0 }}>
      <table style={{ width: "100%", borderCollapse: "collapse", fontSize: ".8rem" }}>
        <thead>
          <tr style={{ background: "var(--navy)", color: "#fff" }}>
            <th style={th}>Medicine</th>
            <th style={th}>Category</th>
            <th style={{ ...th, textAlign: "right" }}>Total AMC</th>
            <th style={{ ...th, textAlign: "right" }}>Required (4M)</th>
            <th style={{ ...th, textAlign: "right" }}>Total Stock</th>
            <th style={{ ...th, textAlign: "right" }}>Pipeline</th>
            <th style={{ ...th, textAlign: "right" }}>Procurement Qty</th>
            <th style={{ ...th, textAlign: "center" }}>Status</th>
          </tr>
        </thead>
        <tbody>
          {medicines.map((m, i) => {
            const req = m.amc * 4;
            const procQty = Math.max(0, req - m.stock - m.pipeline);
            const isProcure = procQty > 0;
            return (
              <tr key={i} style={{ background: isProcure ? "#fff5f5" : "" }}>
                <td style={tdBold}>{m.name}</td>
                <td style={tdSub}>
                  <span style={{ background: m.cat === 'EDL' ? '#dbeafe' : '#fef3c7', padding: '2px 8px', borderRadius: 4, fontWeight: 600, fontSize: '.65rem' }}>{m.cat}</span>
                </td>
                <td style={tdRight}>{m.amc.toLocaleString()}</td>
                <td style={tdRight}>{req.toLocaleString()}</td>
                <td style={tdRight}>{m.stock.toLocaleString()}</td>
                <td style={tdRight}>{m.pipeline.toLocaleString()}</td>
                <td style={{ ...tdRight, fontWeight: 700 }}>{isProcure ? procQty.toLocaleString() : "—"}</td>
                <td style={{ ...td, textAlign: "center" }}>
                  {isProcure ? (
                    <span style={badgeRed}>Procure {procQty.toLocaleString()}</span>
                  ) : (
                    <span style={badgeGreen}>Sufficient</span>
                  )}
                </td>
              </tr>
            );
          })}
          {medicines.length === 0 && (
            <tr><td colSpan={8} style={{ textAlign: 'center', padding: 20, color: '#999' }}>Loading...</td></tr>
          )}
        </tbody>
      </table>
    </div>
  );
};

const th = { padding: "10px 14px", textAlign: "left", fontWeight: 600 };
const td = { padding: "8px 14px", borderBottom: "1px solid #eee" };
const tdRight = { ...td, textAlign: "right" };
const tdBold = { ...td, fontWeight: 600 };
const tdSub = { ...td, color: "#64748b" };
const badgeRed = { background: "#fee2e2", color: "#dc2626", padding: "3px 10px", borderRadius: "12px", fontSize: ".72rem", fontWeight: 600 };
const badgeGreen = { background: "#dcfce7", color: "#16a34a", padding: "3px 10px", borderRadius: "12px", fontSize: ".72rem", fontWeight: 600 };

export default MedicineProcurementSection;
